const routes = [
    {
        path: "/departments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "department_index"
        }
    }
];

export default routes;